export interface SEOPageData {
  path: string;
  title: string;
  description: string;
  canonical: string;
  ogTitle?: string;
  ogDescription?: string;
  faq?: { q: string; a: string }[];
  relatedPages?: { path: string; label: string }[];
}

export const seoPages: Record<string, SEOPageData> = {
  "/": {
    path: "/",
    title: "Персональная песня про тебя за 3 минуты | Хит Шеф",
    description: "Создай персональный музыкальный хит про себя или друга за 3 минуты. Бесплатная демоверсия. Готово онлайн от 249 ₽.",
    canonical: "https://hitchef.ru/",
  },
  "/start": {
    path: "/start",
    title: "Создать песню | Хит Шеф",
    description: "Создайте персональную песню онлайн за 3 минуты. Выберите событие и жанр, расскажите историю — получите уникальный трек.",
    canonical: "https://hitchef.ru/start",
  },
  "/pesnya-na-den-rozhdeniya": {
    path: "/pesnya-na-den-rozhdeniya",
    title: "Песня на день рождения на заказ | Хит Шеф",
    description: "Закажи персональную песню на день рождения за 3 минуты. Бесплатная демоверсия. Оригинальный музыкальный подарок онлайн.",
    canonical: "https://hitchef.ru/pesnya-na-den-rozhdeniya",
    faq: [
      { q: "Сколько времени занимает создание песни?", a: "Обычно не более 3 минут." },
      { q: "Можно ли сделать песню смешной?", a: "Да, вы можете указать стиль и настроение." },
      { q: "Нужно ли регистрироваться?", a: "Нет. Создание доступно онлайн без регистрации." },
      { q: "Можно ли сначала послушать демо?", a: "Да, демоверсия доступна перед покупкой полной версии." },
    ],
    relatedPages: [
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pesnya-na-yubiley", label: "Песня на юбилей" },
      { path: "/pesnya-mame-v-podarok", label: "Песня маме в подарок" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
  "/pesnya-v-podarok": {
    path: "/pesnya-v-podarok",
    title: "Песня в подарок на заказ | Хит Шеф",
    description: "Закажи персональную песню в подарок за 3 минуты. Уникальный музыкальный подарок на любой праздник. Бесплатная демоверсия.",
    canonical: "https://hitchef.ru/pesnya-v-podarok",
    faq: [
      { q: "Сколько стоит персональная песня?", a: "Демоверсия бесплатна. Полная версия доступна после прослушивания демо." },
      { q: "Можно ли выбрать жанр?", a: "Да, вы можете выбрать стиль — от поп до рока и рэпа." },
      { q: "Как быстро будет готова песня?", a: "Обычно создание занимает не более 3 минут." },
      { q: "Нужно ли устанавливать приложение?", a: "Нет. Создание доступно онлайн без установки." },
    ],
    relatedPages: [
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-devushke-v-podarok", label: "Песня девушке в подарок" },
      { path: "/pesnya-mame-v-podarok", label: "Песня маме в подарок" },
      { path: "/pesnya-rebenku-v-podarok", label: "Песня ребёнку в подарок" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
  "/pesnya-pro-druga": {
    path: "/pesnya-pro-druga",
    title: "Песня про друга на заказ | Хит Шеф",
    description: "Закажи персональную песню про друга за 3 минуты. Весёлый и оригинальный подарок другу. Бесплатная демоверсия.",
    canonical: "https://hitchef.ru/pesnya-pro-druga",
    faq: [
      { q: "Можно ли добавить смешные факты про друга?", a: "Конечно! Чем больше деталей вы расскажете, тем круче получится песня." },
      { q: "Друг узнает, что песня про него?", a: "Да, текст создаётся персонально — с именем, историями и деталями." },
      { q: "Сколько времени занимает создание?", a: "Обычно не более 3 минут." },
      { q: "Можно ли выбрать стиль песни?", a: "Да — доступны поп, рок, рэп, шансон и другие жанры." },
    ],
    relatedPages: [
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-kollege-v-podarok", label: "Песня коллеге в подарок" },
      { path: "/pesnya-dlya-vecherinki", label: "Песня для вечеринки" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
  "/pesnya-dlya-vecherinki": {
    path: "/pesnya-dlya-vecherinki",
    title: "Песня для вечеринки на заказ | Хит Шеф",
    description: "Закажи персональную песню для вечеринки за 3 минуты. Уникальный хит для компании друзей. Бесплатная демоверсия.",
    canonical: "https://hitchef.ru/pesnya-dlya-vecherinki",
    faq: [
      { q: "Можно ли сделать песню про всю компанию?", a: "Да! Расскажите про друзей, и мы упомянем всех в тексте." },
      { q: "Подойдёт ли песня для корпоратива?", a: "Конечно — можно сделать весёлый хит про коллег или начальника." },
      { q: "Сколько длится песня?", a: "Демоверсия — около 20 секунд, полная версия — полноценный трек." },
      { q: "Можно ли выбрать танцевальный жанр?", a: "Да — доступны поп, электро, диско и другие энергичные стили." },
    ],
    relatedPages: [
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pesnya-kollege-v-podarok", label: "Песня коллеге в подарок" },
      { path: "/pesnya-na-vypusknoj", label: "Песня на выпускной" },
    ],
  },
  "/pesnya-devushke-v-podarok": {
    path: "/pesnya-devushke-v-podarok",
    title: "Песня девушке в подарок — персональный хит | Хит Шеф",
    description: "Подарите девушке песню с вашей историей. Персональный трек за 3 минуты. Романтичный сюрприз, который она не забудет.",
    canonical: "https://hitchef.ru/pesnya-devushke-v-podarok",
    relatedPages: [
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-na-godovshchinu", label: "Песня на годовщину" },
      { path: "/pesnya-na-svadbu", label: "Песня на свадьбу" },
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
  "/pesnya-mame-v-podarok": {
    path: "/pesnya-mame-v-podarok",
    title: "Песня маме в подарок — трек с вашей историей | Хит Шеф",
    description: "Подарите маме персональную песню с вашей семейной историей. Уникальный трек за 3 минуты. Тёплый подарок, который растрогает до слёз.",
    canonical: "https://hitchef.ru/pesnya-mame-v-podarok",
    relatedPages: [
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-na-yubiley", label: "Песня на юбилей" },
      { path: "/pesnya-rebenku-v-podarok", label: "Песня ребёнку в подарок" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
  "/pesnya-na-svadbu": {
    path: "/pesnya-na-svadbu",
    title: "Песня на свадьбу на заказ — персональный хит | Хит Шеф",
    description: "Закажите персональную песню на свадьбу с вашей историей любви. Уникальный трек за 3 минуты — идеальный подарок молодожёнам.",
    canonical: "https://hitchef.ru/pesnya-na-svadbu",
    relatedPages: [
      { path: "/pesnya-devushke-v-podarok", label: "Песня девушке в подарок" },
      { path: "/pesnya-na-godovshchinu", label: "Песня на годовщину" },
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pozdravlenie-v-stihah", label: "Поздравление в стихах" },
    ],
  },
  "/pesnya-na-yubiley": {
    path: "/pesnya-na-yubiley",
    title: "Песня на юбилей на заказ — персональный хит | Хит Шеф",
    description: "Закажите персональную песню на юбилей — с историей юбиляра, его именем и характером. Уникальный подарок за 3 минуты.",
    canonical: "https://hitchef.ru/pesnya-na-yubiley",
    relatedPages: [
      { path: "/pesnya-mame-v-podarok", label: "Песня маме в подарок" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-kollege-v-podarok", label: "Песня коллеге в подарок" },
      { path: "/pozdravlenie-v-stihah", label: "Поздравление в стихах" },
    ],
  },
  "/pesnya-na-vypusknoj": {
    path: "/pesnya-na-vypusknoj",
    title: "Песня на выпускной на заказ — персональный хит | Хит Шеф",
    description: "Закажите персональную песню на выпускной — про ваш класс, учителей и школьные годы. Уникальный трек за 3 минуты.",
    canonical: "https://hitchef.ru/pesnya-na-vypusknoj",
    relatedPages: [
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-rebenku-v-podarok", label: "Песня ребёнку в подарок" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pesnya-kollege-v-podarok", label: "Песня коллеге в подарок" },
    ],
  },
  "/pesnya-kollege-v-podarok": {
    path: "/pesnya-kollege-v-podarok",
    title: "Песня коллеге в подарок — персональный хит | Хит Шеф",
    description: "Подарите коллеге персональную песню с рабочими историями и шутками. Уникальный трек за 3 минуты — лучший корпоративный подарок.",
    canonical: "https://hitchef.ru/pesnya-kollege-v-podarok",
    relatedPages: [
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pesnya-dlya-vecherinki", label: "Песня для вечеринки" },
      { path: "/pesnya-na-yubiley", label: "Песня на юбилей" },
    ],
  },
  "/pesnya-rebenku-v-podarok": {
    path: "/pesnya-rebenku-v-podarok",
    title: "Песня ребёнку в подарок — персональный хит | Хит Шеф",
    description: "Подарите ребёнку персональную песню с его именем и историей. Уникальный трек за 3 минуты — волшебный подарок для детей любого возраста.",
    canonical: "https://hitchef.ru/pesnya-rebenku-v-podarok",
    relatedPages: [
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-na-vypusknoj", label: "Песня на выпускной" },
      { path: "/pesnya-mame-v-podarok", label: "Песня маме в подарок" },
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
    ],
  },
  "/pesnya-na-godovshchinu": {
    path: "/pesnya-na-godovshchinu",
    title: "Песня на годовщину на заказ — персональный хит | Хит Шеф",
    description: "Закажите персональную песню на годовщину — с вашей историей любви и общими воспоминаниями. Уникальный подарок за 3 минуты.",
    canonical: "https://hitchef.ru/pesnya-na-godovshchinu",
    relatedPages: [
      { path: "/pesnya-na-svadbu", label: "Песня на свадьбу" },
      { path: "/pesnya-devushke-v-podarok", label: "Песня девушке в подарок" },
      { path: "/pesnya-mame-v-podarok", label: "Песня маме в подарок" },
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
  "/originalnyi-podarok": {
    path: "/originalnyi-podarok",
    title: "Оригинальный подарок — персональная песня на заказ | Хит Шеф",
    description: "Ищете оригинальный подарок? Персональная песня с вашей историей — уникальный трек за 3 минуты. Подарок, которого нет ни у кого.",
    canonical: "https://hitchef.ru/originalnyi-podarok",
    relatedPages: [
      { path: "/pesnya-devushke-v-podarok", label: "Песня девушке в подарок" },
      { path: "/pesnya-mame-v-podarok", label: "Песня маме в подарок" },
      { path: "/pesnya-pro-druga", label: "Песня про друга" },
      { path: "/pesnya-kollege-v-podarok", label: "Песня коллеге в подарок" },
      { path: "/pesnya-rebenku-v-podarok", label: "Песня ребёнку в подарок" },
    ],
  },
  "/pozdravlenie-v-stihah": {
    path: "/pozdravlenie-v-stihah",
    title: "Поздравление в стихах с музыкой — персональная песня | Хит Шеф",
    description: "Закажите поздравление в стихах с музыкой — персональная песня с уникальным текстом за 3 минуты. Стихи, которые звучат.",
    canonical: "https://hitchef.ru/pozdravlenie-v-stihah",
    relatedPages: [
      { path: "/pesnya-v-podarok", label: "Песня в подарок" },
      { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
      { path: "/pesnya-na-yubiley", label: "Песня на юбилей" },
      { path: "/pesnya-na-svadbu", label: "Песня на свадьбу" },
      { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
    ],
  },
};

export const getSEOData = (path: string): SEOPageData | undefined => {
  return seoPages[path];
};
